import React from 'react'
import { MorphReplace } from 'react-svg-morph'
import PropTypes from 'prop-types'

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <path d="m12.656 3.699.92.92-7.142 7.141-4.46-4.46.92-.919 3.54 3.54z" />
    </svg>
  )
}

const Check = (props) => {
  const { width, height, fill } = props
  return (
    <MorphReplace width={width} height={height} fill={fill}>
      <Icon />
    </MorphReplace>
  )
}

// 默认参数
Check.defaultProps = {
  width: 16,
  height: 16,
  fill: 'rgba(0,0,0,0.40)',
}
// 参数类型
Check.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
}

export default Check
